export default "/images/vendor/flag-icon-css/flags/4x3/eg.svg?de66162867f147fe1ca131dfd82467c2";